module.exports = __webpack_public_path__ + "static/img/two.81092e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/8/two.png
// module id = QQIt
// module chunks = 1